/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
    LeadToJSONTyped,
} from './Lead';

/**
 * 
 * @export
 * @interface CreateLead201Response
 */
export interface CreateLead201Response {
    /**
     * 
     */
    data?: Lead;
}

/**
 * Check if a given object implements the CreateLead201Response interface.
 */
export function instanceOfCreateLead201Response(value: object): value is CreateLead201Response {
    return true;
}

export function CreateLead201ResponseFromJSON(json: any): CreateLead201Response {
    return CreateLead201ResponseFromJSONTyped(json, false);
}

export function CreateLead201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLead201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadFromJSON(json['data']),
    };
}

export function CreateLead201ResponseToJSON(json: any): CreateLead201Response {
    return CreateLead201ResponseToJSONTyped(json, false);
}

export function CreateLead201ResponseToJSONTyped(value?: CreateLead201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadToJSON(value['data']),
    };
}

